import { render, staticRenderFns } from "./CredentialingPublic.vue?vue&type=template&id=2afc1b45&scoped=true&"
import script from "./CredentialingPublic.vue?vue&type=script&lang=js&"
export * from "./CredentialingPublic.vue?vue&type=script&lang=js&"
import style0 from "./CredentialingPublic.vue?vue&type=style&index=0&id=2afc1b45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc1b45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afc1b45')) {
      api.createRecord('2afc1b45', component.options)
    } else {
      api.reload('2afc1b45', component.options)
    }
    module.hot.accept("./CredentialingPublic.vue?vue&type=template&id=2afc1b45&scoped=true&", function () {
      api.rerender('2afc1b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/CredentialingPublic.vue"
export default component.exports